import { render, staticRenderFns } from "./showChannel.vue?vue&type=template&id=9e61680c&"
import script from "./showChannel.vue?vue&type=script&lang=ts&"
export * from "./showChannel.vue?vue&type=script&lang=ts&"
import style0 from "./showChannel.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports